import { render, staticRenderFns } from "./IdInput.vue?vue&type=template&id=ace10f80&scoped=true&"
import script from "./IdInput.vue?vue&type=script&lang=js&"
export * from "./IdInput.vue?vue&type=script&lang=js&"
import style0 from "./IdInput.vue?vue&type=style&index=0&id=ace10f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace10f80",
  null
  
)

export default component.exports